/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserChart} from '@fortawesome/pro-duotone-svg-icons';

const IndustryLeaderIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserChart} {...props} />
);

export default IndustryLeaderIcon;
